import {
  CountUp
} from 'countup.js'

jQuery(document).ready(function ($) {
  let scroll = window.requestAnimationFrame || function (callback) {
    window.setTimeout(callback, 1000 / 60)
  };
  let animateFadeUp = document.querySelectorAll('.u-animate__fade-up');
  let animateFadeDown = document.querySelectorAll('.u-animate__fade-down');
  let animateBorderDown = document.querySelectorAll('.u-animate__border-down');

  const ANIMATE_CLASS = 'animate'

  // Call the loop for the first time
  loop();
  $(document).on('load', watchCounters)
  $(window).on('scroll', watchCounters)

  // var elementsToShow = document.querySelectorAll('.u-animate-media');
  // var borderToAnimate = document.querySelectorAll('.u-animate__border-top');
  // var animateBorderTop = document.querySelectorAll('.u-animate__border-top');
  // var animateBorderBottom = document.querySelectorAll('.u-animate__border-bottom');

  /**
   * 
   * @param {Element} element 
   */
  function toggleAnimateClass(element) {
    if (isElementInViewport(element)) {
      element.classList.add(ANIMATE_CLASS)
    }
  }

  function watchCounters() {
    $('.counter-block > .number')
      .not('.active')
      .each((index, element) => {
        if (isElementInViewport(element)) {
          element.classList.add('active')
          let counter = new CountUp(element, element.dataset.number)
          counter.start();
        }
    })
  }


  function loop() {
    animateFadeUp.forEach(toggleAnimateClass)
    animateFadeDown.forEach(toggleAnimateClass)
    animateBorderDown.forEach(toggleAnimateClass)

    // animateBorderTop.forEach(function(element) {
    //     if (isElementInViewport(element)) {
    //         element.classList.add('animate');

    //     } else {
    //         element.classList.remove('animate');
    //     }
    // });
    // animateBorderBottom.forEach(function(element) {
    //     if (isElementInViewport(element)) {
    //         element.classList.add('animate');

    //     } else {
    //         element.classList.remove('animate');
    //     }
    // });
    // animateServiceImages.forEach(function(element) {
    //     if (isElementInViewport(element)) {
    //         element.classList.add('animate');
    //     } else {
    //         element.classList.remove('animate');
    //     }
    // });

    scroll(loop);
  }

  // Helper function from: http://stackoverflow.com/a/7557433/274826
  function isElementInViewport(el) {
    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }
    var rect = el.getBoundingClientRect();
    return (
      (rect.top <= 0 &&
        rect.bottom >= 0) ||
      (rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight)) ||
      (rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
    );
  }
});